import CrudCustom from '../../../libs/custom/CrudCustom';

let TipeAkun = new CrudCustom('/tipe-akuns');
export default TipeAkun;
